import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePortfolioData } from '../contexts/DataContext';
import { Code, Database, Wrench, Container } from 'lucide-react';

const SkillBar = ({ skill }) => (
  <div className="mb-5">
    <div className="flex items-center justify-between mb-1.5">
      <span className={`text-sm font-semibold ${skill.is_primary ? 'text-lime-400' : 'text-gray-300'}`}>{skill.name}</span>
      <span className="text-gray-500 text-xs">{skill.level}%</span>
    </div>
    <div className="w-full bg-gray-800 rounded-full h-2 overflow-hidden">
      <div className={`h-full transition-all duration-1000 ease-out rounded-full ${skill.is_primary ? 'bg-lime-400' : 'bg-gray-600'}`} style={{ width: `${skill.level}%` }} />
    </div>
  </div>
);

const Skills = () => {
  const { t } = useLanguage();
  const { skills, loading } = usePortfolioData();

  if (loading) return null;

  const categories = [
    { title: t('skills.languages'), icon: <Code className="text-lime-400" size={28} />, items: skills.languages, bg: 'bg-gray-900' },
    { title: t('skills.databases'), icon: <Database className="text-lime-400" size={28} />, items: skills.databases, bg: 'bg-gray-900' },
    { title: t('skills.frameworks'), icon: <Wrench className="text-lime-400" size={28} />, items: skills.frameworks, bg: 'bg-gray-900' },
    { title: t('skills.devops'), icon: <Container className="text-lime-400" size={28} />, items: skills.devops, bg: 'bg-gray-900' }
  ];

  return (
    <section id="skills" data-testid="skills-section" className="py-20 bg-gray-950">
      <div className="container max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-lime-400 uppercase tracking-tight mb-6">{t('skills.title')}</h2>
          <div className="w-24 h-1 bg-lime-400 mx-auto"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {categories.map((cat, i) => (
            <div key={i} data-testid={`skill-category-${i}`} className={`${cat.bg} border border-gray-800 rounded-2xl p-8 hover:border-lime-400/30 transition-all duration-300`}>
              <div className="flex items-center space-x-4 mb-6">{cat.icon}<h3 className="text-base md:text-lg font-bold text-white uppercase tracking-wide">{cat.title}</h3></div>
              {cat.items.map((skill) => <SkillBar key={skill.id} skill={skill} />)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
